import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';

import { useDeleteTemplateSavedMessage } from '../hooks/useDeleteTemplateSavedMessage';
import { Close } from '@mui/icons-material';
import { DeleteIcon } from '../../../vectors/index';

type TemplateDeleteSavedMessageModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  messageId: number;
  templateId: number;
};

const TemplateDeleteSavedMessageModal: FC<
  TemplateDeleteSavedMessageModalProps
> = ({ isOpen, handleClose, messageId, templateId }) => {
  const [errorText, setErrorText] = useState('');

  const { deleteSavedMessage, isDeletingSavedMessage } =
    useDeleteTemplateSavedMessage({
      setErrorText,
    });

  const handleDelete = () =>
    deleteSavedMessage(
      {
        saved_message_id: messageId,
        etemplate_id: templateId,
      },
      {
        onSuccess: () => {
          handleClose();
        },
      },
    );

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
        <br />
        <DeleteIcon />
        <Typography variant="h4" mt={2}>
          Delete selected message?
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mb: 3 }}>
          {errorText && (
            <Alert sx={{ margin: '10px 0' }} severity="error">
              {errorText}
            </Alert>
          )}
          <LoadingButton
            variant="outlined"
            color="error"
            onClick={handleDelete}
            loading={isDeletingSavedMessage}
          >
            Delete
          </LoadingButton>
          <Button
            disabled={isDeletingSavedMessage}
            variant="contained"
            color="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default TemplateDeleteSavedMessageModal;
